// @ts-ignore
export const setLayers = (state, all) => {
  state.all = all;
};
// @ts-ignore
export const setQuickCatchment = (state, status) => {
  state.quickCatchment = status;
};
// @ts-ignore
export const setLastCatchment = (state, lastCatchment) => {
  state.lastCatchment = lastCatchment;
};
// @ts-ignore
export const setInfoDialog = (state, val) => {
  state.infoDialog = val;
};
// @ts-ignore
export const setWelcomeDialog = (state, val) => {
  state.welcomeDialog = val;
};
